<template>
  <div>
    <v-navigation-drawer 
      theme="dark"
      rail
      expand-on-hover
      :model-value="mdAndUp"
    >
      <v-list>
        <SideBarLink
          v-for="sidebarLink in props.sidebarLinks"
          :key="sidebarLink.name"
          :sidebar-link="sidebarLink"
        />
      </v-list>
      <template v-slot:append>
        <v-list>
          <SideBarLink
            v-for="lowerSidebarLink in props.lowerSidebarLinks"
            :key="lowerSidebarLink.name"
            :sidebar-link="lowerSidebarLink"
          />
        </v-list>
      </template>
    </v-navigation-drawer>
  </div>
</template>
<script setup lang="ts">
import SideBarLink from '@/layout/components/sidebar/SideBarLink.vue';
import { defineProps } from 'vue';
import { SidebarLink } from '@/router/sidebarLinksCreator';
import { useDisplay } from 'vuetify';

const props = defineProps<{
  sidebarLinks: SidebarLink[];
  lowerSidebarLinks: SidebarLink[];
}>();

const { mdAndUp } = useDisplay();
</script>
